@import (reference) '../../../../../constants/spacing.module.less';
@import '../../../../../constants/screen-width-breakpoints.module.less';

.modalContent {
  max-width: 880px;

  @media @tablet, @desktop, @widescreen, @ultrawide {
    width: 720px;
  }
}

.modalBody {
  display: flex;
  flex-flow: column nowrap;
  height: 592px;
}

.modalHeader {
  background-color: var(--default--background-color--1);
  white-space: nowrap;
}

.modalHeaderText {
  font-weight: 200;
}

.modalStepper {
  padding: @space-24 @space-40;
}
